const menu = [
  {
    icon: "dashboard-fill",
    text: "Dashboard",
    link: "/",
  },
  {
    icon: "users-fill",
    text: "MI Services",
    link: "/mi-services",
    active: false,
    subMenu: [
      {
        text: "Coaches & Mentor",
        link: "/coaches",
      },
      {
        text: "Consultants & Trainers",
        link: "/consultants",
      },
      {
        text: "Bookings",
        link: "/bookings",
      },
    ],
  },
  {
    icon: "setting-alt-fill",
    text: "Categories",
    link: "/categories",
  },
  // {
  //   icon: "setting-alt-fill",
  //   text: "Admin",
  //   active: false,
  //   subMenu: [
  //     // {
  //     //   text: "Roles",
  //     //   link: "/roles",
  //     // },
  //     // {
  //     //   text: "Role Permissions",
  //     //   link: "/role-permissions",
  //     // },
  //     // {
  //     //   text: "Sub Admin",
  //     //   link: "/administrators",
  //     // },
  //     {
  //       text: "JotForms",
  //       link: "/jot-forms",
  //     },
  //     {
  //       text: "Sign Up Categories",
  //       link: "/categories",
  //     },
  //   ],
  // },
  {
    icon: "alarm-alt",
    text: "Events",
    link: "/events",
  },
  {
    icon: "img-fill",
    text: "MI Library",
    active: false,
    subMenu: [
      {
        text: "Assets",
        link: "/mi-library",
      },
      {
        text: "Categories",
        link: "/mi-library/categories",
      },
      {
        text: "Purchases",
        link: "/mi-library/purchases",
      },
    ],
  },
  {
    icon: "list-fill",
    text: "Forums",
    link: "/forums",
  },
  {
    icon: "home-fill",
    text: "Shops",
    active: false,
    subMenu: [
      {
        text: "Products",
        link: "/products",
      },
      {
        text: "Orders",
        link: "/orders",
      },
    ],
  },
  {
    icon: "edit-alt",
    text: "Branding Submissions",
    link: "/branding-submissions",
  },
  {
    icon: "mail",
    text: "Contact Us",
    link: "/contact-us",
  },
  {
    icon: "user-list",
    text: "Manage Users",
    link: "/users",
  },
  {
    icon: "img-fill",
    text: "Manage Social",
    link: "/posts",
  },
  // {
  //   icon: "col-3s",
  //   text: "Subscriptions",
  //   link: "/subscriptions",
  // },
  {
    icon: "report",
    text: "Reports",
    link: "/reports",
  },
];
export default menu;
